module.exports = __webpack_public_path__ + "img/04.2c21bc1f.png";